import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { QuotationsPage } from '@/areas/quotations/Quotations/QuotationsPage';
import { canViewQuotation } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/projects/$projectId/quotation')({
    staticData: { access: { permissions: canViewQuotation }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <QuotationsPage {...pathParams} />;
}
